import React from "react";
import ChatInterface from "../chat/components/ui/inputs/ChatInterface";
// import SlackConnection from "../../../stories/SlackConnection";

export default function Messages() {
  return (
    <>
    {/* <SlackConnection /> */}
      <ChatInterface />
    </>
  );
}
